class CustomSliderComponent extends HTMLElement {
  constructor() {
    super();

    this.media = this.querySelector('.u-article_media');
    this.cardReverse = this.querySelector('.u-article-card.text-content');
    this.cardBcgImage = this.querySelector('.u-article-card.bcg-image');
    this.sliderArrowBack = this.querySelector('.u-slider__arrow--back');
    this.sliderArrowForward = this.querySelector('.u-slider__arrow--forward');

    if (this.media) {
      if (!this.cardBcgImage) {
        if (this.cardReverse) {
          this.sliderArrowBack.style.bottom = this.media.offsetHeight / 2 + 'px';
          this.sliderArrowForward.style.bottom = this.media.offsetHeight / 2 + 'px';
          this.sliderArrowBack.style.top = 'auto';
          this.sliderArrowForward.style.top = 'auto';
          this.sliderArrowBack.style.transform = 'translate3d(-50%, 50%, 0)';
          this.sliderArrowForward.style.transform = 'translate3d(50%, 50%, 0)';
          this.sliderArrowBack.style.opacity = 1;
          this.sliderArrowForward.style.opacity = 1;
        } else {
          this.sliderArrowBack.style.top = this.media.offsetHeight / 2 + 'px';
          this.sliderArrowForward.style.top = this.media.offsetHeight / 2 + 'px';
          this.sliderArrowBack.style.opacity = 1;
          this.sliderArrowForward.style.opacity = 1;
        }
      } else {
        this.sliderArrowBack.style.opacity = 1;
        this.sliderArrowForward.style.opacity = 1;
      }
    } else {
      if (this.sliderArrowBack) this.sliderArrowBack.style.opacity = 1;
      if (this.sliderArrowForward) this.sliderArrowForward.style.opacity = 1;
    }


    this.slider_container = this.querySelector(".u-grid");
    this.slider_item = this.querySelector(".u-slider__item");
    if (this.slider_item) {
      this.slider_item_width = this.slider_item.offsetWidth;
    }
    this.sectionWrapper = this.closest('.shopify-section');
    this.enableDynamicMobileHeight = Boolean(this.closest('.mission-slider-mobile-dynamic'));
    this.arrowsInitialized = false;
    this.arrowsRetryAttempted = false;

    // Ensure slider_container exists
    if (!this.slider_container) {
      console.warn('CustomSliderComponent: slider_container (.u-grid) not found');
    }
    // this.querySelectorAll(".slide-indicator")
    //     .forEach((dot, index) => {
    //         dot.addEventListener("click", () => navigate(index));
    //         dot.addEventListener("mouseenter", () => clearInterval(autoplay));
    //     });
    // Add keyboard handlers
    this.addEventListener("keydown", (e) => {
      if (e.code === "ArrowLeft") {
        // clearInterval(autoplay);
        this.navigate("backward");
      } else if (e.code === "ArrowRight") {
        // clearInterval(autoplay);
        this.navigate("forward");
      }
    });

    let _scrollRaf = null;
    this.slider_container.addEventListener('scroll', (e) => {
      if (_scrollRaf) return;
      _scrollRaf = requestAnimationFrame(() => {
        _scrollRaf = null;
        const newScrollPosition = e.target.scrollLeft;
        if (this.querySelector('.u-slider__dots')) {
          this.querySelectorAll('.u-slider__dots .active').forEach(item => {
            item.classList.remove('active');
          });
          const sliderItems = this.querySelectorAll('.u-slider__item');
          for (var k in sliderItems) {
            if (sliderItems[k].offsetLeft >= newScrollPosition) {
              this.querySelector('.u-slider__dots .u-slider__dots-item:nth-of-type(' + (parseInt(k) + 1) + ')').classList.add('active');
              break;
            }
          }
        }
        this.syncSliderHeight();
        this.updateBoundaryArrows();
        this.updateFadeState();
      });
    }, { passive: true })
    this.addEventListener('scroll', () => {
      this.updateFadeState();
    }, { passive: true });

    // Add resize handler
    window.addEventListener("resize", () => {
      this.slider_item_width = this.slider_item.offsetWidth;
      this.checkArrows();
      this.syncSliderHeight();
      this.updateBoundaryArrows();
      this.updateFadeState();
    });
    this.addEventListener("slider-shown", () => {
      this.checkArrows();
      this.syncSliderHeight();
      this.updateBoundaryArrows();
      this.updateFadeState();
    })

    this.addEventListener("click", (e) => {
      if (e.target.closest('[data-open-slide]')) {
        this.navigate(parseInt(e.target.closest('[data-open-slide]').dataset.openSlide) - 1)
      }
    });

    window.addEventListener('DOMContentLoaded', () => {
      this.checkArrows();
      this.syncSliderHeight();
      this.updateFadeState();

      if (this.closest('.grid-with-simplebar')) {
        this.style.minHeight = `${this.clientHeight + 5}px`;
        this.style.overflow = 'auto';
        this.simplebar = new SimpleBar(this, {
          autoHide: false,
        });
      }
    })
    // Autoplay
    // const autoplay = setInterval(() => navigate("forward"), 3000);
    // slideContainerEl.addEventListener("mouseenter", () => clearInterval(autoplay));
    // this.slideObserver = new IntersectionObserver((entries, observer) => {
    //     entries.forEach(entry => {
    //         if (entry.isIntersecting) {
    //             this.slider_item_index = entry.target.dataset.slideindex;
    //             this.querySelector('.slide-indicator.active').classList.remove('active');
    //             carouselEl.querySelectorAll('.slide-indicator')[slideIndex].classList.add('active');
    //         }
    //     });
    // }, { root: slideContainerEl, threshold: .1 });
    // document.querySelectorAll('.slide').forEach((slide) => {
    //     slideObserver.observe(slide);
    // });
  }
  getNewScrollPosition = (arg) => {
    const gap = +window
      .getComputedStyle(this.slider_container)
      .getPropertyValue("column-gap")
      .slice(0, 2),
      scroll_left = Math.round(this.slider_container.scrollLeft),
      slider_width = Math.round(this.slider_container.clientWidth),
      slider_scroll_width = Math.round(this.slider_container.scrollWidth),
      max_scroll_left = slider_scroll_width - slider_width;
    if (arg === "forward") {
      const x = scroll_left + slider_width;
      return x > max_scroll_left
        ? max_scroll_left - scroll_left < 5
          ? 0
          : max_scroll_left
        : x;
    } else if (arg === "backward") {
      const x = scroll_left - slider_width;
      return x < 0 ? (scroll_left == 0 ? max_scroll_left : 0) : x;
    } else if (typeof arg === "number") {
      const x = arg * (this.slider_item_width + gap);
      return x;
    }
  };
  navigate = (arg) => {
    this.slider_container.scrollLeft = this.getNewScrollPosition(arg);
    this.syncSliderHeight();
    this.updateFadeState();
  };

  getActiveSlide = () => {
    if (!this.slider_container) return null;

    const sliderItems = Array.from(this.querySelectorAll('.u-slider__item'));
    if (!sliderItems.length) return null;

    const scrollLeft = this.slider_container.scrollLeft;
    let closestSlide = sliderItems[0];
    let closestDistance = Math.abs(sliderItems[0].offsetLeft - scrollLeft);

    sliderItems.forEach((item) => {
      const distance = Math.abs(item.offsetLeft - scrollLeft);
      if (distance < closestDistance) {
        closestDistance = distance;
        closestSlide = item;
      }
    });

    return closestSlide;
  };

  syncSliderHeight = () => {
    if (!this.enableDynamicMobileHeight || !this.slider_container) return;

    if (!window.matchMedia('(max-width: 767px)').matches) {
      this.slider_container.style.height = '';
      this.slider_container.style.transition = '';
      return;
    }

    const activeSlide = this.getActiveSlide();
    if (!activeSlide) return;

    const activeSlideHeight = activeSlide.offsetHeight;
    if (activeSlideHeight > 0) {
      this.slider_container.style.height = `${activeSlideHeight}px`;
      this.slider_container.style.transition = 'height 220ms ease';
    }
  }
  checkArrows = () => {
    if (this.hasAttribute('hide-arrows-if-not-required')) {
      let grid = this.querySelector('.u-grid')
      if (this.clientWidth + 10 >= grid.children[grid.children.length - 1].offsetLeft + grid.children[grid.children.length - 1].clientWidth) {
        this.querySelectorAll('.u-slider__arrow').forEach((arrow) => arrow.style.display = 'none')
      } else {
        this.querySelectorAll('.u-slider__arrow').forEach((arrow) => arrow.style.display = 'inline-flex')
      }
    }
  }

  updateBoundaryArrows = () => {
    if (!this.slider_container || !this.sliderArrowBack || !this.sliderArrowForward) return;
    const scrollLeft = Math.round(this.slider_container.scrollLeft);
    const maxScroll = Math.round(this.slider_container.scrollWidth - this.slider_container.clientWidth);
    const isAtStart = scrollLeft <= 5;
    const isAtEnd = maxScroll <= 5 || scrollLeft >= maxScroll - 5;
    const back = /** @type {HTMLElement} */ (this.sliderArrowBack);
    const fwd = /** @type {HTMLElement} */ (this.sliderArrowForward);
    // display:none cannot be transitioned — disappears instantly with no animation.
    back.style.display = isAtStart ? 'none' : '';
    fwd.style.display = isAtEnd ? 'none' : '';
  }

  updateFadeState = () => {
    const fadeWrapper = this.closest('.u-grid-mobile-fade');
    if (!fadeWrapper || !this.slider_container) return;

    if (!window.matchMedia('(max-width: 767px)').matches) {
      fadeWrapper.classList.remove('has-left-fade', 'has-right-fade');
      return;
    }

    const gridMaxScroll = Math.max(0, this.slider_container.scrollWidth - this.slider_container.clientWidth);
    const componentMaxScroll = Math.max(0, this.scrollWidth - this.clientWidth);
    const gridIsScroller = this.slider_container.classList.contains('u-slider-mobile') || gridMaxScroll >= componentMaxScroll;
    const scroller = gridIsScroller ? this.slider_container : this;
    const maxScroll = Math.max(gridMaxScroll, componentMaxScroll);
    const items = this.querySelectorAll('.u-slider__item');
    const firstItem = items[0];
    const lastItem = items[items.length - 1];

    if (maxScroll <= 5 || !firstItem || !lastItem) {
      fadeWrapper.classList.remove('has-left-fade', 'has-right-fade');
      return;
    }

    const scrollerRect = scroller.getBoundingClientRect();
    const firstItemRect = firstItem.getBoundingClientRect();
    const lastItemRect = lastItem.getBoundingClientRect();
    fadeWrapper.classList.toggle('has-left-fade', firstItemRect.left < scrollerRect.left - 2);
    fadeWrapper.classList.toggle('has-right-fade', lastItemRect.right > scrollerRect.right + 2);
  }

  connectedCallback() {
    // Ensure sectionWrapper is set
    if (!this.sectionWrapper) {
      this.sectionWrapper = this.closest('.shopify-section');
    }

    // Initialize arrow click handlers when component is connected to DOM
    if (!this.arrowsInitialized) {
      // Wait for next tick to ensure DOM is fully ready
      setTimeout(() => {
        this.initializeArrows();
        this.syncSliderHeight();
        this.updateFadeState();
        this.arrowsInitialized = true;
      }, 0);
    }
  }

  initializeArrows() {
    // Add click handlers - query from this element first (arrows are inside custom-slider-component)
    let backArrows = Array.from(this.querySelectorAll(".u-slider__arrow--back"));
    let forwardArrows = Array.from(this.querySelectorAll(".u-slider__arrow--forward"));

    // Also check sectionWrapper as fallback in case arrows are outside this component
    if (backArrows.length === 0 && this.sectionWrapper) {
      backArrows = Array.from(this.sectionWrapper.querySelectorAll(".u-slider__arrow--back"));
    }
    if (forwardArrows.length === 0 && this.sectionWrapper) {
      forwardArrows = Array.from(this.sectionWrapper.querySelectorAll(".u-slider__arrow--forward"));
    }

    // Filter out hidden arrows
    backArrows = backArrows.filter(arrow => {
      const style = window.getComputedStyle(arrow);
      return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
    });
    forwardArrows = forwardArrows.filter(arrow => {
      const style = window.getComputedStyle(arrow);
      return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
    });

    // If still no arrows found, try again after a short delay (DOM might not be fully ready)
    if ((backArrows.length === 0 || forwardArrows.length === 0) && !this.arrowsRetryAttempted) {
      this.arrowsRetryAttempted = true;
      setTimeout(() => {
        this.initializeArrows();
      }, 300);
      return;
    }

    if (backArrows.length === 0 || forwardArrows.length === 0) {
      // Don't log warning if arrows are intentionally hidden by settings
      return;
    }

    backArrows.forEach((arrow) => {
      // Set cursor and pointer-events to ensure it's clickable
      arrow.style.cursor = 'pointer';
      arrow.style.pointerEvents = 'auto';
      arrow.style.zIndex = '10';

      // Remove any existing listeners by using a unique attribute
      if (arrow.dataset.listenerAttached) {
        return; // Already has listener
      }
      arrow.dataset.listenerAttached = 'true';

      arrow.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (!this.slider_container) {
          this.slider_container = this.querySelector(".u-grid");
        }
        if (this.slider_container) {
          this.navigate("backward");
        } else {
          console.error('CustomSliderComponent: Cannot navigate - slider_container not found');
        }
      });
    });

    forwardArrows.forEach((arrow) => {
      // Set cursor and pointer-events to ensure it's clickable
      arrow.style.cursor = 'pointer';
      arrow.style.pointerEvents = 'auto';
      arrow.style.zIndex = '10';

      // Remove any existing listeners by using a unique attribute
      if (arrow.dataset.listenerAttached) {
        return; // Already has listener
      }
      arrow.dataset.listenerAttached = 'true';

      arrow.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (!this.slider_container) {
          this.slider_container = this.querySelector(".u-grid");
        }
        if (this.slider_container) {
          this.navigate("forward");
        } else {
          console.error('CustomSliderComponent: Cannot navigate - slider_container not found');
        }
      });
    });

    // Update boundary arrow visibility now that listeners are attached
    this.updateBoundaryArrows();
  }
}
customElements.define("custom-slider-component", CustomSliderComponent);
